<div class="mt-16 w-full">
  <!-- Header Section -->
  <div class="px-6 lg:px-16">
    @if (magazine() && edition()) {
      <div class="mt-6">
        <dhp-breadcrumbs [crumbs]="breadcrumbItems()"></dhp-breadcrumbs>
      </div>
      <dhp-edition-header
        [magazine]="magazine()!"
        [edition]="edition()!"
      ></dhp-edition-header>
    } @else if (notFound()) {
      <p class="mt-6">{{ 'pages.editions.notFound' | translate }}</p>
    }
  </div>

  <!-- Divider -->
  <div class="px-6 lg:px-16">
    <hr class="mt-2 mb-2 w-full" />
  </div>

  <!-- Additional Sections -->
  @if (magazine() && edition()) {
    <div class="px-6 lg:px-16">
      <div class="w-full bg-primary-background">
        <div class="flex flex-col justify-start gap-4 py-8">
          <!-- Header -->
          <div
            class="border-borderColor-secondary flex items-center justify-between gap-2 border-b pb-6"
          >
            <h1
              class="flex-1 text-3xl leading-relaxed font-medium text-neutral-900 md:text-5xl"
            >
              {{ 'pages.editions.articles' | translate }}
            </h1>
            @if (articles().length > 0) {
              <dhp-filter-group
                [articleAmount]="filteredArticles().length"
                (resetFilters)="onResetArticleTypeFilter()"
              >
                <div class="flex flex-nowrap gap-3" desktopFilters>
                  <dhp-article-type-select-filter
                    [selected]="selectedArticleTypes()"
                    (selectedArticleTypes)="onArticleTypesChange($event)"
                  ></dhp-article-type-select-filter>
                </div>
                <div mobileFilters>
                  <dhp-article-type-select-filter
                    [selected]="selectedArticleTypes()"
                    (selectedArticleTypes)="onArticleTypesChange($event)"
                  ></dhp-article-type-select-filter>
                </div>
              </dhp-filter-group>
            }
          </div>
          @if (selectedArticleTypes(); as selectedTypes) {
            @if (selectedTypes.size > 0) {
              <div class="flex flex-wrap gap-2">
                @for (type of selectedTypes; track type) {
                  <button
                    class="group inline-flex h-8 max-w-full items-center justify-center gap-2 truncate rounded-full border border-gray-400 bg-neutral-50 py-1.5 pr-2 pl-4 focus:border-ocean-blue-500 focus:bg-neutral-100 focus:outline-none md:max-w-[280px]"
                    [attr.aria-label]="
                      'Remove ' + ('articleTypes.' + type | translate)
                    "
                    (click)="removeArticleType(type)"
                    (keydown.enter)="removeArticleType(type)"
                    (keydown.space)="
                      removeArticleType(type); $event.preventDefault()
                    "
                    role="button"
                  >
                    <div
                      class="truncate text-xs leading-5 font-medium text-neutral-800"
                    >
                      {{ 'articleTypes.' + type | translate }}
                    </div>
                    <div class="relative">
                      <svg
                        class="relative z-10 h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.4933 5.28711L9.95747 8.82211L6.42247 5.28711L5.24414 6.46544L8.77914 10.0004L5.24414 13.5354L6.42247 14.7138L9.95747 11.1788L13.4933 14.7138L14.6716 13.5354L11.1366 10.0004L14.6716 6.46544L13.4933 5.28711Z"
                          fill="#181A1B"
                        />
                      </svg>
                    </div>
                  </button>
                }
              </div>
            }
          }
          @if (filteredArticles().length > 0) {
            <dhp-article-list
              [articles]="filteredArticles()"
              [embedContext]="'edition'"
            ></dhp-article-list>
          }
        </div>
      </div>
    </div>
    @if (hasPreviousEditions()) {
      <div
        class="border-b border-secondary-border bg-secondary-background px-6 pb-8 lg:px-16"
      >
        <dhp-previous-editions-section
          [magazine]="magazine()!"
          [currentEdition]="edition()"
          [editions]="editions()"
        ></dhp-previous-editions-section>
      </div>
    }
    <!-- Disabled functionality. The titlekey and descriptions for this element should be re-evaluated when enabled. Make relative to journal/magazine title. -->
    <!-- <div class="bg-primary-background">
    <dhp-get-notifications-section
      *ngIf="edition()"
      titleKey="components.editionOverview.stayUpdated"
      descriptionKey="components.editionOverview.notificationDescription"
    ></dhp-get-notifications-section>
  </div> -->
  }
</div>

<!-- Year Filter Dialog Component -->
<dhp-year-filter-dialog
  [(isOpen)]="isYearFilterOpen"
  [(yearSelected)]="yearSelected"
  [years]="years()"
></dhp-year-filter-dialog>
